module.exports = __webpack_public_path__ + "static/media/code2.9611c960.PNG";